import React, { useState, useEffect, useCallback, useMemo } from "react";
import Banner from './Banner.png';
import RatingForm from "./RatingForm";
import './App.css';
import { FaStore, FaPhoneAlt, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import { MdDirections } from "react-icons/md";
import { FaShare } from "react-icons/fa6";
import debounce from 'lodash.debounce';

const StoreCard = ({ 
  store, 
  timingsData, 
  ratingsData, 
  onOpenRatingForm 
}) => {
  const phoneNumber = "9278411411";
  
  const timings = timingsData?.timings || "Timings not available";
  const closedInfo = timingsData?.closed || "";
  const rating = ratingsData?.average || 0;
  const ratingCount = ratingsData?.count || 0;

  const renderStars = (average) => {
    const fullStars = Math.floor(average);
    const hasHalfStar = average % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    
    return (
      <>
        {[...Array(fullStars)].map((_, i) => (
          <span key={`full-${i}`} className="star filled">★</span>
        ))}
        {hasHalfStar && <span className="star half">★</span>}
        {[...Array(emptyStars)].map((_, i) => (
          <span key={`empty-${i}`} className="star">☆</span>
        ))}
      </>
    );
  };

  const whatsappShareLink = `https://wa.me/?text=Check Out AutoForm Brand Store: ${store.StoreName}%0A Address: ${store.StoreAdd}%0A Timings: ${timings}%0A Contact: ${phoneNumber}%0A Location: ${encodeURIComponent(store.StoreLoc)}`;

  return (
    <div className="card">
      <div className="store-info">
        <div className="store-detail">
          <div className="store-item">
            <FaStore className="store-icon" />
            <span style={{ fontWeight: 'bold', textTransform: 'capitalize' }}>{store.StoreName}</span>
          </div>

          <div className="store-item">
            <FaMapMarkerAlt className="store-icon2" /> {store.StoreAdd}
          </div>

          <div className="store-item">
            <FaClock className="store-icon" />
            <span>{timings}</span>
            {timings.toLowerCase().includes("closed") ? (
              <p className="Closed">Closed</p>
            ) : (
              <p className="open">Open</p>
            )}
          </div>

          {closedInfo && (
            <div className="closed-info" style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
              <FaClock className="Closed-info-icon" style={{ marginRight: '5px', color: '#ff0000' }} />
              <small style={{ color: '#ff0000' }}>{closedInfo}</small>
            </div>
          )}

          <div className="ratings">
            <span className="stars">{renderStars(rating)}</span>
            <span className="score">{rating.toFixed(1)}</span>
            <span className="rating-count">| {ratingCount} ratings</span>
            <a 
              href="#" 
              className="add-rating" 
              onClick={(e) => { 
                e.preventDefault(); 
                onOpenRatingForm(store.StoreID);
              }}
            >
              | Add Rating
            </a>
          </div>

          <div className="store-item">
            <FaPhoneAlt className="store-icon" />
            <a href={`tel:${phoneNumber}`} className="phone-link">
              {phoneNumber}
            </a>
          </div>
        </div>
      </div>
      <div className="btons">

      <a href={store.StoreLoc} target="_blank" rel="noopener noreferrer">
        <button className="locate-button">
          <div className="lol"><MdDirections /></div>
          Get Directions
        </button>
      </a>

      <a href={whatsappShareLink} target="_blank" rel="noopener noreferrer">
        <button className="share-button">
          <div className="lol"><FaShare /></div>
          Share Details
        </button>
      </a>
      </div>
    </div>
  );
};

const App = () => {
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [stores, setStores] = useState([]);
  const [isLoading, setIsLoading] = useState({
    states: false,
    cities: false,
    stores: false,
    search: false,
    data: false
  });
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [storeTimings, setStoreTimings] = useState({});
  const [storeRatings, setStoreRatings] = useState({});
  const [activeRatingStoreId, setActiveRatingStoreId] = useState(null);
  
  const API_BASE_URL = 'https://emporio1-1blc.vercel.app';

  useEffect(() => {
    fetchStates();
  }, []);

  const debouncedSearch = useCallback(
    debounce(() => {
      if (searchQuery.trim()) {

        setSelectedState("");
        setSelectedCity("");
        setCities([]);
        searchStoresByLocation();
      } else {
        resetDropdowns();
        setStores([]);
        setIsDataLoaded(false);
      }
    }, 500),
    [searchQuery]
  );

  useEffect(() => {
    if (searchQuery) {
      debouncedSearch();
    }
    return () => {
      debouncedSearch.cancel();
    };
  }, [searchQuery, debouncedSearch]);

  useEffect(() => {
    if (stores.length > 0) {
      batchFetchStoreData();
    }
  }, [stores]);


  const resetDropdowns = () => {
  setSelectedState("");
  setSelectedCity("");
  setCities([]);
  setStores([]);
  setIsDataLoaded(false);
  // setSearchQuery("")// clear the seacrh input
};

  const fetchStates = async () => {
    try {
      setIsLoading(prev => ({ ...prev, states: true }));
      const response = await fetch(`${API_BASE_URL}/getallstate`);
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      setStates(data);
    } catch (err) {
      console.error('Error fetching states:', err);
    } finally {
      setIsLoading(prev => ({ ...prev, states: false }));
    }
  };

  const fetchCitiesByState = async (stateId) => {
    if (!stateId) return;
    
    try {
      setIsLoading(prev => ({ ...prev, cities: true }));
      const response = await fetch(`${API_BASE_URL}/getCitiesByState`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ state_id: stateId }),
      });

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      
      const data = await response.json();
      setCities(data);
    } catch (error) {
      console.error('Error fetching cities:', error);
    } finally {
      setIsLoading(prev => ({ ...prev, cities: false }));
    }
  };

  const fetchStoresByCity = async (cityId) => {
    if (!cityId) return;

    setIsLoading(prev => ({ ...prev, stores: true }));
    setStores([]);
    
    try {
      const response = await fetch(`${API_BASE_URL}/getStore`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ cityid: cityId }),
      });

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      
      const data = await response.json();
      setStores(data);
    } catch (error) {
      console.error('Error fetching stores:', error);
    } finally {
      setIsLoading(prev => ({ ...prev, stores: false }));
      setIsDataLoaded(true);
    }
  };
const searchStoresByLocation = async () => {
  if (!searchQuery.trim()) {
    alert('Please enter a location to search.');
    return;
  }

setSelectedCity("");
setSelectedState("");
setCities([]);

  
  setIsLoading(prev => ({ ...prev, search: true }));
  setStores([]);
  
  try {
    const stateResponse = await fetch(`${API_BASE_URL}/getStorebyState`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ stateid: searchQuery }),
    });

    if (stateResponse.ok) {
      const stateData = await stateResponse.json();
      if (stateData.length > 0) {
        setStores(stateData);
      } else {
        await searchStoresByCity(searchQuery);
      }
    } else {
      await searchStoresByCity(searchQuery);
    }
  } catch (error) {
    console.error('Error searching stores:', error);
  } finally {
    setIsLoading(prev => ({ ...prev, search: false }));
    setIsDataLoaded(true);
  }
};

  const searchStoresByCity = async (cityName) => {
    try {
      setIsLoading(prev => ({ ...prev, search: true }));
      const response = await fetch(`${API_BASE_URL}/getStorebyname`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ cityname: cityName }),
      });

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      
      const data = await response.json();
      setStores(data);
    } catch (error) {
      console.error('Error fetching stores by city name:', error);
    } finally {
      setIsLoading(prev => ({ ...prev, search: false }));
    }
  };

  const batchFetchStoreData = async () => {
    if (!stores.length) return;

    setIsLoading(prev => ({ ...prev, data: true }));
    const storeIds = stores.map(store => store.StoreID);
    
    const timingsPromises = storeIds.map(storeId => 
      fetch(`${API_BASE_URL}/getStoreTimings`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ storeid: storeId }),
      })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.json();
      })
      .then(data => ({
        storeId,
        timings: data.timings || "Timings not available",
        closed: data.Closed || data.closed || "",
      }))
      .catch(error => {
        console.error(`Error fetching timings for store ${storeId}:`, error);
        return { storeId, timings: "Timings not available", closed: "" };
      })
    );
    
    const ratingsPromises = storeIds.map(storeId => 
      fetch(`${API_BASE_URL}/getRatings/${storeId}`)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.json();
      })
      .then(data => ({
        storeId,
        average: parseFloat(data.averageRating) || 0,
        count: parseInt(data.ratingCount) || 0,
      }))
      .catch(error => {
        console.error(`Error fetching ratings for store ${storeId}:`, error);
        return { storeId, average: 0, count: 0 };
      })
    );
    
    try {
      const [timingsResults, ratingsResults] = await Promise.all([
        Promise.all(timingsPromises),
        Promise.all(ratingsPromises)
      ]);
      
      const timingsMap = {};
      const ratingsMap = {};
      
      timingsResults.forEach(item => {
        timingsMap[item.storeId] = { timings: item.timings, closed: item.closed };
      });
      
      ratingsResults.forEach(item => {
        ratingsMap[item.storeId] = { average: item.average, count: item.count };
      });
      
      setStoreTimings(timingsMap);
      setStoreRatings(ratingsMap);
    } catch (error) {
      console.error('Error in batch fetching store data:', error);
    } finally {
      setIsLoading(prev => ({ ...prev, data: false }));
    }
  };

  const handleStateChange = (e) => {
    const stateId = e.target.value;
    setSelectedState(stateId);
    setSelectedCity("");
    setStores([]);
    setIsDataLoaded(false);

    if(stateId) {
    setSearchQuery("");// clears the search query
    fetchCitiesByState(stateId);
    }
  };

  const handleCityChange = (e) => {
    const cityId = e.target.value;
    setSelectedCity(cityId);

    if(cityId){
    setSearchQuery(""); // clear the search input
  
      fetchStoresByCity(cityId);
    
    } else {
      setStores([]);
      setIsDataLoaded(false);
    }
  };

  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (!value.trim()) {
      resetDropdowns();
      setStores([]);
      setIsDataLoaded(false);
    }
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      searchStoresByLocation();
    }
  };

  const handleOpenRatingForm = (storeId) => {
    setActiveRatingStoreId(storeId);
  };

  const handleCloseRatingForm = () => {
    setActiveRatingStoreId(null);
    if (stores.length > 0) {
      batchFetchStoreData();
    }
  };

  const storeCards = useMemo(() => {
    return stores.map(store => (
      <StoreCard 
        key={store.StoreID} 
        store={store} 
        timingsData={storeTimings[store.StoreID]}
        ratingsData={storeRatings[store.StoreID]}
        onOpenRatingForm={handleOpenRatingForm}
      />
    ));
  }, [stores, storeTimings, storeRatings]);

  // Combined loading state for any operation
  const anyLoading = isLoading.stores || isLoading.search || isLoading.data;

  return (
    <>
      <div className="c bg-white-400 text-black px-0 mr-0">
     
        <div className="container">
          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-5xl text-center font-bold mb-2 sm:mb-4 md:mb-6">
            CONNECT WITH YOUR NEAREST AUTOFORM STORE
          </h1>

          <div className="line border-0 dark:bg-yellow-400"></div>

          {/* Dropdown Filters */}
          <div className="Search-bars">
            <div className="row">
              <div className="col">
                <select
                  className="form-select"
                  onChange={handleStateChange}
                  value={selectedState}
                  disabled={isLoading.states}
                >
                  <option value="">Select State</option>
                  {states.map((state) => (
                    <option key={state.StateID} value={state.StateID}>
                      {state.StateName}
                    </option>
                  ))}
                </select>
                {isLoading.states && (
                  <div className="text-center mt-2">
                    <div className="spinner-border spinner-border-sm text-primary" role="status">
                      <span className="visually-hidden">Loading states...</span>
                    </div>
                  </div>
                )}
              </div>
              <div className="col">
                <select
                  disabled={!selectedState || isLoading.cities}
                  className="form-select"
                  onChange={handleCityChange}
                  value={selectedCity}
                >
                  <option value="">Select City</option>
                  {cities.map((city) => (
                    <option key={city.CityID} value={city.CityID}>
                      {city.CityName}
                    </option>
                  ))}
                </select>
                {isLoading.cities && (
                  <div className="text-center mt-4">
  <div className="spinner-border spinner-border-sm text-primary" role="status">

  </div>
  <div className="mt-2">
    <span style={{ color: '#0d6efd', fontWeight: '500', fontSize: '16px' }}>
      {/* Loading cities... */}
    </span>
  </div>
</div>
                )}
              </div>
            </div>
          </div>
          <div className="line border-0 dark:bg-yellow-200"></div>
        </div>
      </div>
      
      <div className="search-bar-container">
        <div className="search-form">
          <input
            type="text"
            className="search-input"
            placeholder="Enter location"
            value={searchQuery}
            onChange={handleSearchInputChange}
            onKeyDown={handleSearchKeyDown}
            disabled={isLoading.search}
          />
        </div>
      </div>
      
      <div className="Par-all">
        <p>
          Autoform India Pvt. Ltd. is India's leading manufacturer of premium seat covers, car accessories, and infotainment systems, 
          committed to enhancing comfort, style, and innovation. Our journey began in 1989 with high-quality seat cover production,
          leading to national expansion in 1999. In 2009, we registered 'Autoform,' setting new industry benchmarks. The launch of mats
          and car interior accessories in 2014 further expanded our offerings. With the opening of our first brand stores in Delhi NCR in 2016, 
          we accelerated growth—reaching 100 stores in Vijayawada by 2019 and 200 stores in Dehradun in 2022, marking Emporio's first outlet.
          By 2024, we proudly crossed 350 stores, reinforcing our position as India's premier automotive accessories brand.
          Visit our Autoform franchise stores nationwide to explore our top-quality products and upgrade your driving experience. 
          Find your nearest store today!
        </p>
      </div>
      
      {/* Main loading indicator for stores */}
      {anyLoading && (
        <div className="text-center my-5">
  <div
    className="spinner-border text-primary custom-spinner"
    style={{ width: '3rem', height: '3rem' }}
    role="status"
  >
    {/* <span className="visually-hidden">Loading...</span> */}
  </div>
  <p style={{ marginTop: '1rem', color: '#0d6efd', fontWeight: '500', fontSize: '18px' }}>
    Loading Stores, please wait...
  </p>
</div>
      )}
      
      {/* Content display when not loading */}
      {!anyLoading && (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '300px',
            textAlign: 'center',
          }}
        >
          {stores.length > 0 ? (
            storeCards
          ) : isDataLoaded ? (
            <h1 className="no-stores-message">No Stores are Available!</h1>
          ) : null}
        </div>
      )}
      
      {activeRatingStoreId && (
        <div className="popup-overlay">
          <div className="popup-content">
            <button className="close-btn" onClick={handleCloseRatingForm}>×</button>
            <RatingForm 
              storeId={activeRatingStoreId} 
              onClose={handleCloseRatingForm} 
            />
          </div>
        </div>
      )}
    </>
  );
};

export default App;